/**
 * One organization's management page for LATO staff: profile, staff agent tokens, members, invites
 * and generated profiles (`AdminWorkspacePanel`). Its studies
 * are one click away on the admin studies board, filtered to this organization.
 */

import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft, FlaskConical } from "lucide-react";
import { AdminWorkspacePanel } from "@/features/dashboard/AdminWorkspacePanel";
import { useAdminOrganizations } from "@/hooks/useAdmin";

function WorkspaceDetail() {
  const { orgId } = Route.useParams();
  const { data: orgs } = useAdminOrganizations();
  const org = orgs?.find((o) => o.id === orgId);

  return (
    <div className="h-full overflow-y-auto">
      <div className="mx-auto max-w-3xl space-y-6 px-4 py-6 sm:px-6 sm:py-8">
        <Link
          to="/admin/workspaces"
          className="inline-flex items-center gap-1.5 text-caption text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="size-3.5" />
          Workspaces
        </Link>
        <div className="flex flex-wrap items-center justify-between gap-3">
          <h1 className="text-[28px] font-light leading-tight tracking-tight text-foreground">
            {org?.name ?? "Workspace"}
          </h1>
          <Link
            to="/admin/studies"
            search={{ org: orgId }}
            className="inline-flex items-center gap-2 rounded-md border border-border px-3 py-1.5 text-sm text-foreground transition-colors hover:bg-muted/60"
          >
            <FlaskConical className="size-4" />
            View studies
          </Link>
        </div>
        <AdminWorkspacePanel orgId={orgId} />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_auth/admin/workspaces/$orgId")({
  component: WorkspaceDetail,
});
